export default {
      id: "file-chart-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#file-chart-outline-usage",
      toString: function () {
        return this.url;
      }
    }